import React, { useState, useEffect } from "react";
import { getReq } from "../middleware/AxiosApisCall";

function DataList(props) {
  const [dataList, setDataList] = useState([]);
   
  const loadList = async () => {
    const response = await getReq(`${props.path}/Datalist`);
    setDataList(response.data);
  };

  useEffect(() => {
    loadList();
  }, []);

  return (
    <React.Fragment>
      <label htmlFor={props.name}>{props.heading}</label>
      <input
        list={props.name}
        name={props.name}
        onChange={props.handleChange}
        value={props.value}
        placeholder={"Select..."}
        autoComplete={"off"}
        style={{ textAlign: "left" }}
       
      />

      <datalist id={props.name}>
        {dataList.length>0 ? (
          dataList.map((e, i) => {
            return (
              <option key={i} value={e.id}>

                {e[props.option]}
               {/* { props.price ? (e[props.option]+' '+ e[props.price] +'rs' ):(e[props.option] ) } */}
              </option>
            );
          })
        ) : (
          <option>{props.error || "Something Went wrong"}</option>
        )}
      </datalist>
    </React.Fragment>
  );
}

export default DataList;
